const STORAGE_KEY = 'amber-peak-portal-favorite-units';
const MAX_FAVORITES = 50;

function normalizeUnitIds(values: string[]): string[] {
  const seen = new Set<string>();
  const ids: string[] = [];
  for (const value of values) {
    const trimmed = value.trim();
    if (!trimmed || trimmed.length > 120 || seen.has(trimmed)) continue;
    seen.add(trimmed);
    ids.push(trimmed);
    if (ids.length >= MAX_FAVORITES) break;
  }
  return ids;
}

/** Keep unit ids from the amberpeak.ca link until the shortlist can save them. */
export function rememberWebsiteFavorites(search: string): void {
  const raw = new URLSearchParams(search).get('favorites');
  if (raw === null) return;
  const ids = normalizeUnitIds(raw.split(','));
  if (ids.length === 0) {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

export function peekWebsiteFavoriteUnitIds(): string[] {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return normalizeUnitIds(parsed.filter((value): value is string => typeof value === 'string'));
  } catch {
    return [];
  }
}

export function clearWebsiteFavoriteUnitIds(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
